/**
 * Announce - the GM says something to the whole table as a card in the
 * log (v9.7.0), not as a line of talk that scrolls away with the rest.
 *
 * It is the composer's `/announce` with a box of its own: the same vox
 * line of kind `system`, to the table, in nobody's voice
 * (engine/chat/build). The box clears once the line is sent; a refusal
 * leaves the words in it and is said where the vox says its errors.
 *
 * @param {object} props
 * @param {(raw: string) => Promise<boolean>} props.send - the vox's send
 */
import { useState } from 'react';
import common from '../../styles/common.module.css';
import styles from '../../styles/Story.module.css';
import { MAX_TEXT } from '../../engine/chat';

/** `/announce ` itself counts against the line's length. */
const MAX_ANNOUNCE = MAX_TEXT - '/announce '.length;

export default function Announce({ send }) {
  const [text, setText] = useState('');
  const submit = async (e) => {
    e.preventDefault();
    const words = text.trim();
    if (!words) return;
    if (await send(`/announce ${words}`)) setText('');
  };
  return (
    <section className={styles.section} aria-label="Announce">
      <h3 className={styles.caption}>Announce</h3>
      <form className={styles.form} onSubmit={submit}>
        <label className={styles.field}>
          To the whole table, as a card in the log
          <input
            className={styles.input}
            data-testid="announce-input"
            value={text}
            maxLength={MAX_ANNOUNCE}
            onChange={(e) => setText(e.target.value)}
          />
        </label>
        <button type="submit" className={common.btnSmall} data-testid="announce-send" disabled={!text.trim()}>
          Announce
        </button>
      </form>
    </section>
  );
}
